import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { homePearlGloryList } from '../services/General-service';

function MediaShell({ className, url, children }) {
    const href = typeof url === 'string' ? url.trim() : '';
    if (!href) {
        return <div className={className}>{children}</div>;
    }

    const isExternal = /^https?:\/\//i.test(href);
    if (isExternal) {
        return (
            <a className={className} href={href} target="_blank" rel="noopener noreferrer">
                {children}
            </a>
        );
    }

    return (
        <Link className={className} to={href}>
            {children}
        </Link>
    );
}

function PearlGloryCollection({ showpearlglory, sectionTitle }) {
    const [images, setImages] = useState([]);

    useEffect(() => {
        if (!showpearlglory) return;

        homePearlGloryList()
            .then((data) => {
                const list = Array.isArray(data?.data) ? data.data : [];
                setImages(
                    list
                        .map((item) => ({
                            id: item?.id,
                            src: item?.banner_image || item?.image || item?.thumbnail || '',
                            url: item?.url || '',
                        }))
                        .filter((item) => item.src)
                        .slice(0, 3)
                );
            })
            .catch((error) => {
                console.error('Error fetching pearl glory collection:', error);
                setImages([]);
            });
    }, [showpearlglory]);

    if (!showpearlglory || images.length < 3) return null;

    const [hero, lookOne, lookTwo] = images;

    return (
        <div className="pearl-glory-shade">
            <div className="App">
                <div className="BreakPointContainer">
                    <div className="CarouselSectionContainer pearl-glory">
                        <div className="pearl-glory-layout">
                            <MediaShell className="pearl-glory-hero" url={hero.url}>
                                <img src={hero.src} alt="" />
                            </MediaShell>
                            <div className="pearl-glory-content">
                                <div className="SectionTitle">
                                    <h1 className="m-t-0 m-b-15 text-left demi-bold">{sectionTitle || 'PEARL GLORY COLLECTION'}</h1>
                                </div>
                                <p className="pearl-glory-copy">
                                    An exquisite homage to the artistry of pearls. This collection reflects the serene sophistication of pearl embroidery, blending delicate handwork with modern allure. Graceful silhouettes, intricate textures, and a soft luster—designed for effortless elegance.
                                </p>
                                <div className="pearl-glory-looks">
                                    <MediaShell className="pearl-glory-look" url={lookOne.url}>
                                        <img src={lookOne.src} alt="" />
                                    </MediaShell>
                                    <MediaShell className="pearl-glory-look" url={lookTwo.url}>
                                        <img src={lookTwo.src} alt="" />
                                    </MediaShell>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PearlGloryCollection;
